import React from 'react';
import { Button } from '@mui/material';
import { useLoginContext } from '../../../../contexts/LoginContext';

type ButtonProps = React.ComponentProps<typeof Button> & {
  children: React.ReactNode;
  allowNavigation?: boolean; // Kept for backwards compatibility, but not used
};

export const StatefulButton: React.FC<ButtonProps> = ({
  children,
  allowNavigation = false,
  disabled,
  ...rest
}) => {
  const { error } = useLoginContext();

  // Always disable the button when there are validation errors
  // This prevents navigation and actions when form validation fails
  const shouldDisable = error;

  return (
    <Button disabled={shouldDisable || disabled} {...rest}>
      {children}
    </Button>
  );
};
